





















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import HasilPenunjangSvc from "@/services/HasilPenunjang";
import {
  buildSampelLab,
  ItemHasilLab,
  pilihanLabDariTeks,
  SampelHasilLab,
  selaraskanLab
} from "@/utils/klaimRehabMedik";

@Component
export default class TabelPilihHasilLab extends Vue {
  @Prop({ default: null }) readonly value!: string | null;
  @Prop() readonly register!: string | number;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  loading = false;
  gagal = false;
  sampel: SampelHasilLab[] = [];
  dipilih: string[] = [];
  expanded: SampelHasilLab[] = [];

  private token = 0;

  private teksSendiri: string | null = null;

  headers = [
    { text: "Tgl Hasil", value: "tanggal", width: "18%" },
    { text: "Unit", value: "unit", width: "14%" },
    { text: "Acc Oleh", value: "accBy", width: "22%" },
    { text: "Item Pemeriksaan", value: "items", sortable: false },
    { text: "", value: "data-table-expand" }
  ];

  get teksKosong(): string {
    return "Belum ada hasil laboratorium pada kunjungan ini.";
  }

  get jumlahItem(): number {
    return this.sampel.reduce((total, s) => total + s.items.length, 0);
  }

  terpilih(res: ItemHasilLab): boolean {
    return this.dipilih.indexOf(res.key) !== -1;
  }

  jumlahDipilih(item: SampelHasilLab): number {
    return item.items.filter(res => this.terpilih(res)).length;
  }

  semuaDipilih(item: SampelHasilLab): boolean {
    return this.jumlahDipilih(item) === item.items.length;
  }

  sebagianDipilih(item: SampelHasilLab): boolean {
    const jumlah = this.jumlahDipilih(item);

    return jumlah > 0 && jumlah < item.items.length;
  }

  adaKritis(item: SampelHasilLab): boolean {
    return item.items.some(res => res.kritis);
  }

  toggleExpand(item: SampelHasilLab) {
    const posisi = this.expanded.indexOf(item);

    if (posisi === -1) {
      this.expanded = [...this.expanded, item];
    } else {
      this.expanded = this.expanded.filter((_, i) => i !== posisi);
    }
  }

  pilihItem(res: ItemHasilLab, aktif: boolean) {
    const sisa = this.dipilih.filter(key => key !== res.key);

    this.terapkan(aktif ? [...sisa, res.key] : sisa);
  }

  pilihSemua(item: SampelHasilLab, aktif: boolean) {
    this.gantiPilihanSampel(item, aktif ? item.items : []);
  }

  pilihKritis(item: SampelHasilLab) {
    this.gantiPilihanSampel(
      item,
      item.items.filter(res => res.kritis)
    );
  }

  private gantiPilihanSampel(item: SampelHasilLab, baru: ItemHasilLab[]) {
    const milikSampel = item.items.map(res => res.key);
    const sisa = this.dipilih.filter(key => milikSampel.indexOf(key) === -1);

    this.terapkan([...sisa, ...baru.map(res => res.key)]);
  }

  private terapkan(kunci: string[]) {
    const teks = selaraskanLab(this.value, this.sampel, kunci);

    this.dipilih = kunci;
    this.teksSendiri = teks;

    this.$emit("input", teks);
  }

  @Watch("register", { immediate: true })
  onGantiRegister() {
    this.muat();
  }

  @Watch("value")
  onGantiNilai(val: string | null) {
    if (val === this.teksSendiri) return;

    this.turunkanPilihan();
  }

  private turunkanPilihan() {
    this.teksSendiri = this.value;
    this.dipilih = pilihanLabDariTeks(this.value, this.sampel);
  }

  async muat() {
    const reg = this.register;
    const giliran = ++this.token;

    this.sampel = [];
    this.dipilih = [];
    this.expanded = [];
    this.gagal = false;

    if (!reg) return;

    this.loading = true;

    try {
      const resp = await HasilPenunjangSvc.getLabByRegister(reg, true).catch(
        () => null
      );
      if (giliran !== this.token) return;

      this.gagal = resp === null;
      this.sampel = buildSampelLab(
        resp && Array.isArray(resp.data) ? resp.data : []
      );
      this.expanded = this.sampel.length ? [this.sampel[0]] : [];
      this.turunkanPilihan();
    } finally {
      if (giliran === this.token) this.loading = false;
    }
  }
}
